<template>
    <modal size="xl" @close="() => $emit('close')" :open="localOpen" :closeOnBackgroundClick="true" :edgeToEdge="true" borderColor="primary" :borderSize="1">
       
        <template #default>
            <div style="margin-top:-25px;">
                <div style="width:64px; height:64px;" class="mx-auto text-primary">
                    <marquis-circle-icon/>
                </div>
            </div>
            <div class="p-3 my-4 text-center text-light-primary">
                <h4 class="mb-0">Properties within the Marquis Collection are managed and supported by StayMarquis,</h4>
                <h4><em>ensuring an unmatched level of trust, care, and convenience.</em></h4>
            </div>
            <div class="p-3 border-top border-primary">
                <marquis-intro-boxes class="mt-4" />
            </div>

        </template>
    </modal>
</template>

<script type="text/javascript">
    import MarquisCircleIcon from '@/assets/logos/marquis-circle-icon.svg.vue';
    import MarquisIntroBoxes from '@/components/Content/Public/Home/Guests/MarquisIntroBoxes.vue';
    import CommonComponents from '@/components/Common.vue';


    export default {
        components: {
            MarquisCircleIcon,
            MarquisIntroBoxes,
            ...CommonComponents,
        },

        data() {
            return {
                localOpen: true,
            };
        },

        props: {

            open: {
                type: Boolean,
                default: true,
            },
        },

        emits: ['close'],
        
        create() {
            this.localOpen = this.open;
        },

        watch: {
            open(newVal) {
                this.localOpen = newVal;
            },
        },
    };

</script>
